import React, { useState, useEffect } from 'react';
// import Pagination from 'react-js-pagination';
import { Link, useLocation, useParams, useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactPaginate from 'react-paginate';
import clock from 'assets/images/clock.svg';
import previousIcon from 'assets/images/arrow-left.png';
import nextIcon from 'assets/images/arrow-right.png';
import { getLanguage, getPathLanguage, getQueryString } from '../../../../utils/params';
import favorite404 from '../../../../assets/images/notfound-icon.svg';
// import markNew from '../../../../assets/images/New.svg';
// import markNewJP from '../../../../assets/images/New_JP.svg';
// import { isMobile } from '../../../../utils/constants';
import { ArrowRight } from 'assets/images/web-isn';
import { fetchBlogs } from '../../blogs.api';

const ListBlogs = props => {
  const location = useLocation();
  const language = getLanguage(useLocation());
  const [pageNo, setPageNo] = useState();
  const [blogs, setBlogs] = useState();
  const pathLanguage = getPathLanguage(useLocation());
  const params = useParams();
  const { t } = useTranslation();
  const cityId = localStorage.getItem('LOCATION_CITY')
    ? localStorage.getItem('LOCATION_CITY')
    : localStorage.getItem('DEFAULT_CITY');
  const searchParams = new URLSearchParams(useLocation().search);
  // const [pageIndex, setPageIndex] = useState(searchParams.get('pageIndex'));
  const history = useHistory();
  useEffect(() => {
    // let pageNumber = localStorage.getItem('pageNumberBlog');
    // let pageNumber = useState(searchParams.get('pageIndex'))
    let pageIndex = searchParams.get('pageIndex');
    if (pageIndex) {
      setPageNo(pageIndex);
    } else pageIndex = 1;
    if (params.category) {
      if (params.id) {
        props.showLoader();
        fetchBlogs(getQueryString({ language, cityId, categoryId: params.id, pageSize: 6, pageIndex: pageIndex })).then(
          res => {
            // console.log(res);
            props.hideLoader();
            if (res) {
              setBlogs(res);
            }
          },
          rej => {
            console.log(rej);
            props.hideLoader();
          },
        );
      } else {
        props.showLoader();
        fetchBlogs(getQueryString({ language, cityId, categoryId: 0, pageSize: 6, pageIndex: pageIndex })).then(
          res => {
            // console.log(res);
            props.hideLoader();
            if (res) {
              setBlogs(res);
            }
          },
          rej => {
            console.log(rej);
            props.hideLoader();
          },
        );
      }
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    // window.scrollTo(0, 0);
    // const scrollTo = document.querySelector('#blog-position-scroll');
    // if (scrollTo) {
    //   scrollTo.scrollIntoView({ behavior: 'smooth' });
    // }
    // eslint-disable-next-line
  }, [language, cityId, params.id, useLocation().search]);

  const handlePageChange = pageNumber => {
    pageNumber = parseInt(pageNumber.selected) + 1;
    searchParams.set('pageIndex', pageNumber);
    history.push({ pathname: location.pathname, search: searchParams.toString() });
    setPageNo(pageNumber);
    if (params.id) {
      props.showLoader();
      fetchBlogs(getQueryString({ language, cityId, categoryId: params.id, pageSize: 6, pageIndex: pageNumber })).then(
        res => {
          props.hideLoader();
          if (res) {
            setBlogs(res);
          }
        },
        rej => {
          console.log(rej);
          props.hideLoader();
        },
      );
    } else {
      props.showLoader();
      fetchBlogs(getQueryString({ language, cityId, categoryId: 0, pageSize: 6, pageIndex: pageNumber })).then(
        res => {
          props.hideLoader();
          if (res) {
            setBlogs(res);
          }
        },
        rej => {
          console.log(rej);
          props.hideLoader();
        },
      );
    }
    // localStorage.setItem('pageNumberBlog', pageNumber);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    // const scrollTo = document.querySelector('#blog-position-scroll');
    // if (scrollTo) {
    //   scrollTo.scrollIntoView({ behavior: 'smooth' });
    // }
  };

  // const { blogs } = props.blogs;
  // const blogs = {
  //   items: [
  //     {
  //       blogThumnail: "http://crm.vietnamhousing.vn/images/blogs/1619150565494_Reception.jpg",
  //       blogTitle: "Introduction of ISN Serviced Office in Hanoi",
  //       date: "April 22, 2021",
  //       id: "d9b08856-46f0-7217-41ac-60824ccc1854",
  //       isNew: false,
  //       slug: "introduction-of-isn-serviced-office-in-hanoi",
  //       category: 'newly-launched-properties',
  //     },
  //   pageCount: 5,
  //   pageIndex: 1,
  //   pageSize: 6,
  //   totalRecords: 30
  // }
  const lstTitle = {
    title2: t('blogs.news'),
    title3: t('blogs.newly_launched_properties'),
    title4: t('blogs.rental_living_tips'),
    title5: t('blogs.living_in_vietnam'),
  };
  return (
    <>
      {params.category && blogs && blogs.items ? (
        <>
          <span className="title-blog">
            {params.id && Number(params.id) !== 1 ? lstTitle[`title${params.id}`] : t('blogs.all_blogs')}
          </span>
          <div className="lower-border-category"></div>
          <div className="blog-info">
            <div className="row">
              {blogs && blogs.items ? (
                blogs.items.length ? (
                  blogs.items.map((item, index) => {
                    if (item.blogTitle) item.blogTitle = item.blogTitle.replace('　', ' ');
                    return (
                      <div key={index} className="col-12 col-md-4 mb-4">
                        <div className="block-inner">
                          <div className="block-image">
                            <Link
                              to={`${pathLanguage}/blog/${
                                params.category !== 'all-blogs' ? item.categorySlug : 'all-blogs'
                              }/detail/${item.id}/${item.slug}`}
                              className="block-handle-click"
                            >
                              {/* {item.isNew ? (
                                language === 'jp' ? (
                                  <img src={markNewJP} alt="" className="mark-new" />
                                ) : (
                                  <img src={markNew} alt="" className="mark-new" />
                                )
                              ) : (
                                ''
                              )} */}
                              <img alt="" src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.blogThumnail}`} />
                              {/* <LazyLoadImage alt="" src={item.blogThumnail} effect="blur" /> */}
                            </Link>
                          </div>
                          <Link
                            to={`${pathLanguage}/blog/${
                              params.category !== 'all-blogs' ? item.categorySlug : 'all-blogs'
                            }/detail/${item.id}/${item.slug}`}
                            className="d-flex flex-column justify-content-between block-text blog-description text-decoration-none"
                          >
                            <div>
                              <div className="created pb-2">
                                <img alt="" src={clock} />
                                {/* <LazyLoadImage alt="" src={clock} effect="blur" /> */}
                                <span className="font-noto-sans-jp">{item.date}</span>
                              </div>
                              <div
                                className="text-decoration-color-black-hover"
                                to={`${pathLanguage}/blog/${
                                  params.category !== 'all-blogs' ? item.categorySlug : 'all-blogs'
                                }/detail/${item.id}/${item.slug}`}
                              >
                                <h4 className="text-decoration-none text-truncate-box-title-name">{item.blogTitle}</h4>
                              </div>
                            </div>
                            <div
                              className="text-decoration-color-black-hover pt-2"
                              to={`/${language}/blog/${
                                params.category !== 'all-blogs' ? item.categorySlug : 'all-blogs'
                              }/detail/${item.id}/${item.slug}`}
                            >
                              <div className="d-flex mt-2 align-items-center">
                                <span className="read-more mr-3 font-noto-sans-jp">{t('home_page.btn_readmore')}</span>
                                <img className="icon" src={ArrowRight} alt="arrow-icon"></img>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="image-notfound">
                    <div className="not-found-message">{t('blogs.no_blog_found')}</div>
                    <img src={favorite404} className="favourite-notfound" alt="" />
                    {/* <LazyLoadImage className="favourite-notfound" alt="" src={favorite404} effect="blur" /> */}
                  </div>
                )
              ) : (
                ''
              )}
            </div>
            <div className="pagination">
              {blogs && blogs.totalRecords && blogs.totalRecords > 6 ? (
                <ReactPaginate
                  //   activePage={pageNo}
                  //   itemsCountPerPage={6}
                  //   totalItemsCount={blogs.totalRecords || 0}
                  //   pageRangeDisplayed={4}
                  //   hideFirstLastPages={true}
                  //   nextPageText={<LazyLoadImage src={nextIcon} alt="" effect="blur" />}
                  //   prevPageText={<LazyLoadImage src={previousIcon} alt="" effect="blur" />}
                  //   activeClass={'pagination-active'}
                  //   onChange={page => handlePageChange(page)}
                  //   itemClass={'pagination-pager-item'}
                  forcePage={pageNo - 1}
                  pageCount={blogs.pageCount}
                  pageRangeDisplayed={1}
                  marginPagesDisplayed={2}
                  nextLinkClassName={'next-btn'}
                  previousLinkClassName={'prev-btn'}
                  previousLabel={<LazyLoadImage src={previousIcon} alt="" effect="blur" />}
                  nextLabel={<LazyLoadImage src={nextIcon} alt="" effect="blur" />}
                  activeClassName={'pagination-active'}
                  onPageChange={handlePageChange}
                  pageClassName={'pagination-pager-item'}
                  disabledClassName={'opacity-disable'}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListBlogs);
